import naja from "naja";
import SpinnerExtension from "./SpinnerExtension";
import BeforeAfterUpdateExtension from "./BeforeAfterUpdateExtension";

class NajaHandler {
	constructor() {
		this.naja = naja;
		window.naja = this.naja;
	}

	initialize() {
		document.addEventListener("DOMContentLoaded", () => {
			this.registerExtensions();
			this.setupEventHandlers();
			this.naja.initialize();
		});
	}

	registerExtensions() {
		this.naja.registerExtension(new SpinnerExtension());
		this.naja.registerExtension(new BeforeAfterUpdateExtension());
	}

	setupEventHandlers() {
		this.setupRedirectHandler();
		this.setupErrorHandler();
		this.setupAbortHandler();
		this.setupCompleteHandler();
		this.setupSnippetRestoreHandler();
		this.setupHistoryRestoreHandler();

		document.addEventListener("change", this.handleInputChange.bind(this));
		document.addEventListener("click", this.handleClickEvent.bind(this));
	}

	setupRedirectHandler() {
		this.naja.redirectHandler.addEventListener("redirect", (event) => {
			const {url} = event.detail;

			if (url.includes("ajax-file-download")) {
				event.preventDefault();
				this.hideAjaxCover();
				this.setAjaxSpinnerText("Požadavek se zpracovává, čekejte prosím...");

				const link = document.createElement("a");
				link.href = url;
				link.click();
			} else {
				event.preventDefault();
				this.naja.makeRequest("GET", url, null, {forceRedirect: true});
			}
		});
	}

	setupErrorHandler() {
		this.naja.addEventListener("error", (event) => {
			const {response, error} = event.detail;

			if (response?.status === 500) {
				showFlashMessage(error, "error");
			}

			this.hideAjaxCover();
			this.setAjaxSpinnerText("Požadavek se zpracovává, čekejte prosím...");
		});
	}

	setupAbortHandler() {
		this.naja.addEventListener("abort", () => {
			this.hideAjaxCover();
			this.setAjaxSpinnerText("Požadavek se zpracovává, čekejte prosím...");
		});
	}

	setupCompleteHandler() {
		this.naja.addEventListener("complete", ({detail: {payload}}) => {
			if (payload?.redirect && payload.hideModal) {
				const modal = document.getElementById(payload.hideModal);
				if (modal) $(modal).modal("hide");
			}

			if (!$('.modal').is(':visible')) {
				$('body').removeClass('modal-open').css('padding-right', '0');
				document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove());
			}
		});
	}

	setupSnippetRestoreHandler() {
		this.naja.snippetCache.addEventListener("restore", (event) => {
			delete event.detail.snippets["snippet--flashes"];

			const tracyToggle = document.getElementById("tracy-bs-toggle");
			if (tracyToggle) Tracy.Toggle.toggle(tracyToggle);
		});
	}

	setupHistoryRestoreHandler() {
		this.naja.historyHandler.addEventListener("restoreState", (event) => {
			if (!$('.modal').is(':visible')) {
				$('body').removeClass('modal-open').css('padding-right', '0');
				document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove());
			}

			document.querySelector('#ajax-spinner > span').textContent = "Aktualizuji obsah stránky, čekejte prosím...";
			event.stopImmediatePropagation();

			this.naja.makeRequest("GET", event.detail.state.href, null, {history: false}).then(() => {
				this.setAjaxSpinnerText("Požadavek se zpracovává, čekejte prosím...");
			});
		});
	}

	handleInputChange(event) {
		const elem = event.target;
		const role = elem.getAttribute("data-role");

		switch (role) {
			case "paginator-handler":
				this.naja.makeRequest("POST", elem.value);
				break;

			case "form-invalidation":
				this.handleFormInvalidation(elem);
				break;

			case "basic-handler":
				this.handleBasicHandler(elem);
				break;

			case "url-handler":
				this.naja.makeRequest("POST", elem.getAttribute("data-handler"), {urlHandler: true}, {history: elem.getAttribute("data-naja-history")});
				break;

			default:
				break;
		}
	}

	handleClickEvent(event) {
		let elem = event.target;

		if (!elem) return;

		const allowedElems = ["button", "submit", "a"];

		while (!allowedElems.includes(elem.type) && elem.parentElement) {
			elem = elem.parentElement;
		}

		const role = elem.getAttribute("data-role");

		if (role === "basic-handler" && elem.type === "button") {
			this.naja.makeRequest("POST", elem.getAttribute("data-href"));
		} else if (role === "extended-handler" && ["button", "a"].includes(elem.type)) {
			this.naja.makeRequest("POST", elem.getAttribute("data-handler"), {
				[elem.getAttribute("data-handler-parameter")]: elem.getAttribute("data-id")
			});
		}
	}

	handleFormInvalidation(elem) {
		const prefix = elem.getAttribute("data-param-prefix") || "";

		disableAjaxSpinner();
		this.naja.makeRequest("POST", elem.getAttribute("data-handler"), {
			[`${prefix}formData`]: new URLSearchParams(new FormData(elem.form)).toString(),
			[`${prefix}formName`]: elem.getAttribute("data-form-name"),
			[`${prefix}changedItem`]: elem.name
		}, {history: elem.getAttribute("data-naja-history")}).then(enableAjaxSpinner);
	}

	handleBasicHandler(elem) {
		const valueType = elem.getAttribute("data-handler-value-type") || null;
		const multipleParams = elem.getAttribute("data-handler-multiple-params") || null;

		let value = ["datepicker", "datetimepicker"].includes(elem.getAttribute("data-provide"))
			? elem.getAttribute("value")
			: (
				elem.type === "checkbox"
					? elem.getAttribute("data-id")
					: elem.value
			);

		if (["float", "int"].includes(valueType) && value === "") {
			value = null;
		}

		const data = {[elem.getAttribute("data-handler-parameter")]: value};

		if (multipleParams) {
			JSON.parse(multipleParams).forEach((id) => {
				const input = document.getElementById(id);
				if (!input) return;

				const param = input.getAttribute("data-handler-parameter");
				if (input.getAttribute("data-provide") === "datepicker") {
					data[param] = input.value ? moment(input.value, "DD. MM. YYYY").format("YYYY-MM-DD") : "";
				} else if (input.getAttribute("data-provide") === "datetimepicker") {
					data[param] = input.value ? moment(input.value, "DD. MM. YYYY  HH:MM").format("YYYY-MM-DD HH:MM") : "";
				} else {
					data[param] = input.value;
				}
			});
		}

		this.naja.makeRequest("POST", elem.getAttribute("data-handler"), data, {history: elem.getAttribute("data-naja-history") ?? false});
	}

	hideAjaxCover() {
		document.getElementById("ajax-cover").style.display = "none";
	}

	setAjaxSpinnerText(text) {
		document.querySelector("#ajax-spinner > span").textContent = text;
	}

}

const najaHandler = new NajaHandler();
window.najaHandler = najaHandler;
najaHandler.initialize();
